import { render } from "./IntercomConversationModal.vue?vue&type=template&id=87d49aa4"
import script from "./IntercomConversationModal.vue?vue&type=script&lang=js"
export * from "./IntercomConversationModal.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./IntercomConversationModal.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_e58f5c89%2Fpackages%2Fbo%2Fsrc%2Fcomponents%2Fintercom%2FIntercomConversationModal.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__